import { axiosHelper } from 'Services/AxiosHelper';
import { CreateInstructionFromQRAccountModel } from 'Models';
import { CreateInstructionFromQRAccountBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'b2c.MBCreateInstructionFromQRAccount';

const createInstructionFromQRAccount = async (
  params: CreateInstructionFromQRAccountBodyData
): Promise<CreateInstructionFromQRAccountModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default createInstructionFromQRAccount;
